import "../design/errorPageStyle.css";

export default function ErrorPage() {
    return (
        <>
            <div className="error-container">
                <h1 className="error-title">Oops! 404 Not Found</h1>
                <p className="error-message">Something went wrong. Please try again later.</p>
                <a href="/" className="error-link">Go back to Home</a>
            </div>
        </>
    )
}